export default __webpack_public_path__ + "static/media/78.a61df699.jpg";